import { SignupFormData } from 'modules/auth/hooks/useSignupForm'
import { EnumAuthTrackingEvents } from 'modules/auth/lib/tracking/events'
import { TextField } from 'modules/common/components/_ui/FormControl/TextField/TextField'
import { useTrackDirtyField } from 'modules/common/hooks/useTrackDirtyField'
import { useTrackOnMount } from 'modules/common/hooks/useTrackOnMount'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useFormContext } from 'react-hook-form'
import { SignupFormActions } from './SignupFormActions'

export const SignupFormName = () => {
  const { t } = useTranslation(['auth-components', 'common'])

  const { register, watch, formState } = useFormContext<SignupFormData>()
  const { errors, touchedFields } = formState

  useTrackDirtyField<SignupFormData>({
    name: 'firstname',
    event: EnumAuthTrackingEvents.SIGNUP_FIRSTNAME_FORM_STARTED,
  })
  useTrackOnMount({
    eventType: EnumAuthTrackingEvents.SIGNUP_FIRSTNAME_FORM_ENTER,
  })

  const firstname = watch('firstname')
  const lastname = watch('lastname')

  const isDisabled =
    !firstname || !lastname || !!errors.firstname || !!errors.lastname

  return (
    <div className="flex flex-col space-y-6 lg:w-124">
      <h2 className="md:text-3xl">{t('signupForm.name.title')}</h2>
      <p className="text-info-400">{t('signupForm.name.subtitle')}</p>
      <TextField
        label={t('signupForm.name.firstname.label')}
        error={touchedFields.firstname ? errors.firstname : undefined}
        autoFocus
        isRequired
        data-amp-mask=""
        {...register('firstname')}
      />
      <TextField
        label={t('signupForm.name.lastname.label')}
        error={touchedFields.lastname ? errors.lastname : undefined}
        isRequired
        data-amp-mask=""
        {...register('lastname')}
      />

      <SignupFormActions
        event={EnumAuthTrackingEvents.SIGNUP_FIRSTNAME_FORM_VALIDATED}
        isNextButtonDisabled={isDisabled}
      />
    </div>
  )
}
